import React from 'react';

import styles from './cellRenderer.scss';

const cellRenderer = ({ cellData }) => (
  <div className={styles.truncatedCell}>{cellData}</div>
);

export default cellRenderer;
